import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import SectionHeading from "../../components/ui/SectionHeading";
import Button from "../../components/ui/Button";
import { servicesData } from "../../data/servicesData";

const serviceIcons = {
  event: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </svg>
  ),
  social: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
    </svg>
  ),
  digital: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
  ),
  construction: (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
    </svg>
  ),
};

export default function ServicesPreview() {
  return (
    <section className="py-20 md:py-28 bg-gold-light/10 border-y border-gold-muted/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          overline="What We Offer"
          title="Services that elevate your brand"
          subtitle="From events to digital marketing and beyond — we deliver end-to-end solutions with a premium touch."
        />
        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {servicesData.map((service, i) => (
            <Link key={service.id} to={`/services/${service.id}`}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ delay: i * 0.1, duration: 0.5 }}
                whileHover={{ y: -4 }}
                className="group relative rounded-xl border border-gold-muted/30 bg-gradient-to-b from-aura-bg via-aura-text to-black p-6 md:p-7 hover:border-gold-primary/60 transition-colors duration-300 h-full block overflow-hidden"
              >
                <div className="absolute inset-0 bg-gradient-to-tr from-gold-primary/20 via-transparent to-gold-light/10 opacity-80" aria-hidden />
                <div className="relative">
                  <div className="flex items-start justify-between gap-3">
                    <div className="w-11 h-11 rounded-sm bg-gold-primary/20 flex items-center justify-center text-gold-dark group-hover:bg-gold-primary/35 transition-colors">
                      {serviceIcons[service.icon] || serviceIcons.event}
                    </div>
                    <span className="inline-flex rounded-full border border-gold-light/60 bg-black/30 px-3 py-1 text-[10px] font-sans uppercase tracking-[0.2em] text-gold-light/90">
                      {service.title.split("&")[0].trim()}
                    </span>
                  </div>
                  <h3 className="mt-4 font-serif text-lg md:text-xl font-semibold text-white">
                    {service.title}
                  </h3>
                  <p className="mt-2 font-sans text-sm text-gold-light/90 line-clamp-3">
                    {service.description}
                  </p>
                  <span className="mt-3 inline-flex items-center gap-1 font-sans text-sm font-medium text-gold-primary group-hover:gap-2 group-hover:underline">
                    Learn more
                    <span aria-hidden>→</span>
                  </span>
                </div>
              </motion.div>
            </Link>
          ))}
        </div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
          className="mt-12 text-center"
        >
          <Button to="/services" variant="primary">
            View All Services
          </Button>
        </motion.div>
      </div>
    </section>
  );
}
